export default "__VITE_ASSET__DFwaUXdd__"